module.exports = __webpack_public_path__ + "img/nav-orange.99ef27b4.svg";